import client from '../httpClient';

const schedulesGetContactsCountApi = (customerId) => {
  return client.get(`/actions/contacts/count/${customerId}`);
};

export default schedulesGetContactsCountApi;
